export let FeedsSortConfiguration = [
  {
    label: 'Created Date: Newest to Oldest',
    field: 'createdDate',
    apiSortField: 'createdDate',
    direction: 'desc',
  },
  {
    label: 'Created Date: Oldest to Newest',
    field: 'createdDate',
    apiSortField: '-createdDate',
    direction: 'asc',
  },
  {
    label: 'Updated Date: Newest to Oldest',
    field: 'respDate',
    apiSortField: 'respDate',
    direction: 'desc',
  },
  {
    label: 'Updated Date: Oldest to Newest',
    field: 'respDate',
    apiSortField: '-respDate',
    direction: 'asc',
  },
];

export let NotificationSortConfiguration = [
  {
    label: 'Created Date: Newest to Oldest',
    field: 'createdDate',
    direction: 'desc',
  },
  {
    label: 'Created Date: Oldest to Newest',
    field: 'createdDate',
    direction: 'asc',
  },
];

export interface FeedRequest {
  clickable?: boolean;
  createdDate?: string;
  feedMessageId?: string;
  feeds: string;
  lastModifiedBy?: string;
  lastModifiedDate?: string;
  level?: string;
  link?: string;
  recordId?: string;
  requestorDate?: string;
  requestorId?: string;
  responderDate?: string;
  roleId?: number;
  status?: string;
  responderId?: string;
}

export interface Notifications {
  feedMessageId?: number;
  feedtypeId?: number;
  domainId?: number;
  requestorDate?: string;
  feeds?: string;
  createdBy?: string;
  createdDate?: string;
  lastModifiedBy?: string;
  lastModifiedDate?: string;
  recordId?: string;
  userId?: string;
  link?: string;
}
